import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons'
import MotionDiv from '../../../../global/motions/MotionDiv'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'
import { seasonalUpdateTypes } from '../../cnr/reducers/reducerHelpers/seasonalDataHelpers'
import { getLevelMatchez } from '../../cnr/reducers/reducerHelpers/seasonSportsData'
import { _rightModes_mdu, MatchDataUpdateContext } from './MatchDataUpdate'
import { sportsHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/sportsHelpers'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { realTimeScoring } from 'projectSpecific/sports/dbActions/realtimeScoring'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { SportsDataContext } from 'projectSpecific/sports/cnr/contexts/SportsDataContext'
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers'
import MatchSquares, { _msTypes } from './MatchSquares'
import { _allowSportsUpdates, useSeasonalData } from 'projectSpecific/sports/useHelpers/useSeasonals'
import { _matchResultSourceTypes } from 'projectSpecific/sports/useHelpers/useMatchResults'

const MatchesUpdateViewer = ({ forPlayoffs, mode_right, matches_haFlip }) => {

  const { updateSeasonalMatches_byLevel } = useSeasonalData()

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainRt } = app_state

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { sportPermissions } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    sportDataSettings,
    latestSeason,
    sportSettings_info,
  } = sportsSeason_state ?? {}

  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}

  const sportsDataContext = useContext(SportsDataContext);
  const { sportsData_handlers: sportsData_handlers_sdc } = sportsDataContext ?? {};

  // matchDataUpdateContext
  const matchDataUpdateContext = useContext(MatchDataUpdateContext);
  const { sportsData_state } = matchDataUpdateContext ?? {};
  const { matchResultsInfo, matchPlayoffPendings, matches_info } = sportsData_state ?? {};
  const { matches_combined, matches_matchDay } = matches_info ?? {};
  const { matchUpdates, matchUpdates_grouped, matchUpdates_dot_mcks } = matchResultsInfo ?? {}

  const [currentLevelMatches, setCurrentLevelMatches] = useState()
  const [matchDayMatchKeys, setMatchDayMatchKeys] = useState()
  const [updatingLocal, setUpdatingLocal] = useState()

  useEffect(() => {
    let levelMatchesToUpdate;
    switch (mode_right) {
      case _rightModes_mdu.confirmMatchDayResults:
        const papa = sportsHelpers.ammendMatchDayMatches(matches_matchDay, matches_combined)
        const _matchDayMatchKeys = papa ? _.keys(papa) : []
        setMatchDayMatchKeys(_matchDayMatchKeys)
        const xxx = sportsHelpers.createMatchUpdateData(papa)
        levelMatchesToUpdate = xxx
        break;
      case _rightModes_mdu.confirmPending:
        const { _levelUpdateMatches } = getLevelMatchez(matchPlayoffPendings);
        levelMatchesToUpdate = _levelUpdateMatches
        break;
      case _rightModes_mdu.confirmResults:
        levelMatchesToUpdate = matchUpdates_dot_mcks // forPlayoffs ? matchUpdates_grouped?.seasonPLayoff : matchUpdates_grouped?.season
        break;
      case _rightModes_mdu.confirmResults_haFlip:
        levelMatchesToUpdate = matches_haFlip //forPlayoffs ? matchUpdates_grouped?.seasonPlayoff : matchUpdates_grouped?.season 
        break;
    }

    _.forEach(levelMatchesToUpdate, (matches, lk) => {
      seasonalHelpers.cleanMatchesForUpdate(matches)
    })

    setCurrentLevelMatches(levelMatchesToUpdate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode_right]);

  const handleUpdate_matches = () => {
    const cb2 = () => {
      setUpdatingLocal(false)
    }
    const cb = () => {

      switch (mode_right) {
        case _rightModes_mdu.confirmResults:
        case _rightModes_mdu.confirmMatchDayResults:
          setUpdatingLocal(false)
          realTimeScoring.deleteRealtimeDatabaseScores(mainRt, _matchResultSourceTypes.matchDay, sportPermissions, sportDataSettings, seasonalUpdateTypes.rtMatches, pathViews, matchDayMatchKeys, null, latestSeason, cb2)
          break;

        default:
          setUpdatingLocal(false)
      }
    }
    setUpdatingLocal(true)

    const _updateProps = {
      forPlayoffs: forPlayoffs,
      pathViews,
      pks: seasonalHelpers.getPks(pathViews, _latestSeason, sportsKey),
      seasonalUpdateType: seasonalUpdateTypes.matchesList,
      useScoringCollection,
      useScoringCollectionOnly,
      sportPermissions,
      dataToUpdate: currentLevelMatches,
      callback: cb
    }

    updateSeasonalMatches_byLevel(_updateProps)

  }

  const footer = () => {
    const btns = []
    btns.push({ oc: handleUpdate_matches, caption: _.startCase(mode_right), icon: 'save', color: _allowSportsUpdates.matches ? 'green' : 'teal' })
    return <UiSaveButtons
      others={btns}
    />
  }

  return <MotionDiv>
    <Wrapper
      header={_.startCase(mode_right)}
      content={
        <MatchSquares matches={currentLevelMatches} msType={_msTypes.date} />
      }
      contentData={currentLevelMatches ? currentLevelMatches : 'No currentLevelMatches'}
      footer={footer()}
      wrapperType={wrapperTypes.paddedHeaderAndFooter}
      updating={updatingLocal}
    ></Wrapper>
  </MotionDiv>


}

export default MatchesUpdateViewer